import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../bootstrap/component/Row'
import Column from '../../bootstrap/component/Column'
import ContentBoxHeader from './ContentBoxHeader'
import ContentBoxBody from './ContentBoxBody'


const ContentBox = ({ children, title }) => {
    return (
        <Row>
            <Column layer="lg" size={12}>
                <div className="content-box">
                    <ContentBoxHeader>
                        <h1>{title}</h1>
                    </ContentBoxHeader>
                    <ContentBoxBody>
                        {children}
                    </ContentBoxBody>
                </div>
            </Column>
        </Row>
    )
}

ContentBox.propTypes = {
    title: PropTypes.string,
}

export default ContentBox



// WEBPACK FOOTER //
// ./src/modules/layout/component/ContentBox.js